import classNames from 'classnames';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { useStores } from '../../../stores/useStores';
import { NotificationDotController } from '../../Notifications/NotificationDotController';
import { useFooterNavigationLogic } from '../useFooterNavigationLogic';

import { FooterAnimations } from './FooterAnimations';
import styles from './FooterNavigation.module.scss';
import { NavigationTab } from './NavigationTab';

export const FooterNavigation = observer(function FooterNavigation() {
  const { pocStore, bingoStore } = useStores();

  const {
    redeemModeAvailable,
    handleOpenFullPageModal,
    handleRewardOpen,
    handleOpenStore,
    handleOpenRedeem,
    handleOpenBingo,
    disableControls,
    hideNavigationBar,
  } = useFooterNavigationLogic();

  const { t } = useTranslation();

  if (hideNavigationBar) {
    return null;
  }

  return (
    <div
      className={classNames(styles.footerNavigation, {
        [styles.controlsDisabled]: disableControls,
      })}
    >
      <FooterAnimations />
      <NavigationTab dialog="store" title={t('footer.store')} onClick={() => handleOpenStore()} />
      <NavigationTab
        comingSoon={!redeemModeAvailable}
        dialog="redeem"
        disabled={!redeemModeAvailable}
        title={redeemModeAvailable ? t('footer.redeem') : undefined}
        onClick={() => handleOpenRedeem()}
      >
        {redeemModeAvailable ? (
          <div className={pocStore.shouldShowHangingSessionMarker ? 'hanging-poc-marker' : undefined} />
        ) : null}
      </NavigationTab>
      <NavigationTab dialog={'home'} title={t('footer.lobby')} onClick={handleOpenFullPageModal} />
      <NavigationTab dialog="rewards" title={t('footer.lounge')} onClick={handleRewardOpen}>
        <div className={styles.notificationDotWrapper}>
          <NotificationDotController type="small" />
        </div>
      </NavigationTab>
      {bingoStore.bingoEnabled ? (
        <NavigationTab dialog="bingo" title={t('footer.bingo')} onClick={() => handleOpenBingo()} />
      ) : (
        <NavigationTab
          additionalDialogs={['loyalty_program']}
          dialog="account"
          title={t('footer.account')}
          onClick={handleOpenFullPageModal}
        />
      )}
    </div>
  );
});
